export type PaylineConfig = {
    api: string;
    contrat: string;
    reference: string;
};

export type ClickToPayConfig = {
    USER: string;
    PASSWORD: string;
};

export type YavinConfig = {
    ID: string;
    CleAPI: string;
    PublicAccountID: string;
};

export const INITIAL_PAYLINE: PaylineConfig = {
    api: "REST",
    contrat: "",
    reference: "",
};

export const INITIAL_CLICKTOPAY: ClickToPayConfig = {
    USER: "",
    PASSWORD: "",
};

export const INITIAL_YAVIN: YavinConfig = {
    ID: "",
    CleAPI: "",
    PublicAccountID: "",
};

export const PAYLINE_REGLEMENT = 1;
export const CLICKTOPAY_REGLEMENT = 3;
export const YAVIN_REGLEMENTS = [4, 6];

export const PAYLINE_API_OPTIONS = ["REST", "SOAP"] as const;
